#import "../fragments/market-fragment.graphql"

query GetMarkets {
    markets {
        edges {
            node {
                ...MarketFragment
            }
        }
    }
}
